import script from "./VenueInfoBlock.vue?vue&type=script&setup=true&lang=js"
export * from "./VenueInfoBlock.vue?vue&type=script&setup=true&lang=js"

import "./VenueInfoBlock.vue?vue&type=style&index=0&id=54fcda99&lang=scss"

const __exports__ = script;

export default __exports__